import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, isLoading } = useAuth();
  const [searchParams] = useSearchParams();
  const isFreePlay = searchParams.get('mode') === 'free';

  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: '#0d1117',
        color: '#e2e8f0',
        fontSize: 18
      }}>
        Loading...
      </div>
    );
  }

  if (!isAuthenticated && !isFreePlay) {
    return <Navigate to="/signin" replace />;
  }

  return children;
}
